import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Link, Card, CardContent } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import img from "../assets/qural1.png";
import MailIcon from '@mui/icons-material/Mail';
import LockIcon from '@mui/icons-material/Lock';
import { makeApiRequest } from '../utils/api';
import { textAlign } from '@mui/system';

function Login({ onLogin }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    setLoading(true);
    try {
      const response = await makeApiRequest('post', '/api/login', {
        email: email,
        password: password
      });

      if (response.status === 'success') {

        localStorage.setItem('authToken', response.data.token);
        localStorage.setItem('username', response.data.username);
        localStorage.setItem('userid', response.data.userid);
        localStorage.setItem('control', response.data.control);
        localStorage.setItem('userLocation', response.data.userLocation);
        localStorage.setItem('id', response.data.id);
        localStorage.setItem('locationList', JSON.stringify(response.data.locationList));
        onLogin(response);

      } else {
        setError('Invalid email or password.');
      }
    } catch (err) {
      console.error('Error loading credentials:', err);
      setError(err.response?.data?.message || 'An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleLogin();
  };

  return (
    <Box sx={{ position: 'relative', width: '100%', height: '100vh', overflow: 'hidden' }}>
      <Box
        sx={{
          width: '100%',
          height: '60vh',
          background: 'linear-gradient(to right, #2353A3 0%, #59C8F2 50%, #FFFFFF 100%)',
        }}
      />
      <Box
        sx={{
          width: 0,
          height: 0,
          borderLeft: '100vw solid transparent',
          borderBottom: '13.9vw solid #ffffff',
          marginTop: '-13.8vw',
        }}
      />

      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '80%', sm: '50%', md: "35%" },
          padding: '20px',
          backgroundColor: 'transparent',
          //  boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
          //  borderRadius: '8px',
          zIndex: 10,
        }}
      >
        <Card
          sx={{
            borderRadius: '8px',
            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
          }}
        >
          <CardContent>
            <Typography variant="h5" component="h2" sx={{ marginBottom: '30px', color: '#333' }}>
              <img style={{ height: "122px", objectFit: 'contain', /* marginLeft: "45px" */ textAlign: 'center', width: '100%' }} src={img} alt="Logo" />

            </Typography>
            {error && (
              <Typography variant="body2" color="error" sx={{ marginBottom: 2 }}>
                {error}
              </Typography>
            )}
            <Box component="form" onSubmit={handleSubmit} autoComplete="off" noValidate>
              <Box sx={{ marginBottom: 5 }}>
                <TextField
                  fullWidth
                  label="Email"
                  type="email"
                  placeholder="Enter your email"
                  variant="outlined"
                  required
                  autoComplete="off"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <MailIcon />
                    ),
                  }}
                  InputLabelProps={{
                    shrink: true, // Keeps the label always floating
                  }}
                />
              </Box>
              <Box sx={{ marginBottom: 5 }}>
                <TextField
                  fullWidth
                  label="Password"
                  type="password"
                  placeholder="Password"
                  variant="outlined"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="new-password"
                  InputProps={{
                    endAdornment: (
                      <LockIcon sx={{ fontSize: '24px' }} />
                    ),
                  }}
                  InputLabelProps={{
                    shrink: true, // Keeps the label always floating
                  }}
                />
              </Box>
              <Box sx={{ marginBottom: '20px', textAlign: 'right' }}>
                <Link
                  component="button"
                  type="button"
                  onClick={() => navigate('/forgot-password')}
                  sx={{ fontSize: '14px', color: '#007BFF', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                >
                  Forgot Password?
                </Link>
              </Box>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                onClick={handleLogin}
                sx={{
                  backgroundColor: '#007BFF',
                  '&:hover': { backgroundColor: '#0056b3' },
                }}>
                Login
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}

export default Login;